/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientCompanyBillingInformationAddressUpdateRequest
 */
export interface ClientCompanyBillingInformationAddressUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyBillingInformationAddressUpdateRequest
     */
    region?: string;
}

/**
 * Check if a given object implements the ClientCompanyBillingInformationAddressUpdateRequest interface.
 */
export function instanceOfClientCompanyBillingInformationAddressUpdateRequest(value: object): value is ClientCompanyBillingInformationAddressUpdateRequest {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function ClientCompanyBillingInformationAddressUpdateRequestFromJSON(json: any): ClientCompanyBillingInformationAddressUpdateRequest {
    return ClientCompanyBillingInformationAddressUpdateRequestFromJSONTyped(json, false);
}

export function ClientCompanyBillingInformationAddressUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyBillingInformationAddressUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'street': json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function ClientCompanyBillingInformationAddressUpdateRequestToJSON(value?: ClientCompanyBillingInformationAddressUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'formattedAddress': value['formattedAddress'],
        'street': value['street'],
        'street2': value['street2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'region': value['region'],
    };
}

